import React from "react"
import { useSelector } from "react-redux"
import { getFormBuilderStateReady, getFormIsSubform } from "reduxSlices/formBuilderSlice"
import { HiddenTabs } from "shared/tabs"
import { tabSlugFromQueryParams } from "utils/tabHelper"
import {
  FORM_BUILDER_DESIGN_TAB_SLUG,
  FORM_BUILDER_FORM_SETTINGS_TAB_SLUG,
  FORM_BUILDER_SUBMISSION_ACCESS_TAB_SLUG,
  FORM_BUILDER_WORKFLOW_TAB_SLUG,
} from "utils/tabSlugHelpers"
import DesignTab from "./DesignTab"
import DesignControls from "./DesignTab/DesignControls"
import SubmissionAccessTab from "./SubmissionAccessTab"
import FormSettingsTab from "./FormSettingsTab"
import WorkflowsTab from "./WorkflowsTab"

const DESIGN_TAB = {
  title: "Design",
  slug: FORM_BUILDER_DESIGN_TAB_SLUG,
  TabContent: DesignTab,
  additionalControls: <DesignControls />,
}

const SUBMISSION_ACCESS_TAB = {
  title: "Submission Access",
  slug: FORM_BUILDER_SUBMISSION_ACCESS_TAB_SLUG,
  TabContent: SubmissionAccessTab,
  additionalControls: null,
}

const WORKFLOW_TAB = {
  title: "Workflow",
  slug: FORM_BUILDER_WORKFLOW_TAB_SLUG,
  TabContent: WorkflowsTab,
  additionalControls: null,
}

const FORM_SETTINGS_TAB = {
  title: "Form Settings",
  slug: FORM_BUILDER_FORM_SETTINGS_TAB_SLUG,
  TabContent: FormSettingsTab,
  additionalControls: null,
}

const REGULAR_FORM_TABS = [
  DESIGN_TAB,
  SUBMISSION_ACCESS_TAB,
  WORKFLOW_TAB,
  FORM_SETTINGS_TAB,
]

const TASK_FORM_TABS = [
  DESIGN_TAB,
  WORKFLOW_TAB,
  FORM_SETTINGS_TAB,
]

const FormBuilderTabs = () => {
  const ready = useSelector(getFormBuilderStateReady)
  const formIsSubform = useSelector(getFormIsSubform)

  if (!ready) return null

  const tabs = formIsSubform ? TASK_FORM_TABS : REGULAR_FORM_TABS

  return (
    <HiddenTabs tabs={tabs} initialActiveSlug={tabSlugFromQueryParams()} />
  )
}

export default FormBuilderTabs
